import type { DeploymentResource } from "~/client/resources";
import type { Client } from "../client";
import type { TaskState } from "../resources/taskState";
import type { ListArgs } from "./basicRepository";
import BasicRepository from "./basicRepository";

type DeploymentListArgs = {
    projects?: string[];
    environments?: string[];
    tenants?: string[];
    channels?: string[];
    taskState?: TaskState;
} & ListArgs;

class DeploymentRepository extends BasicRepository<DeploymentResource, DeploymentResource, DeploymentListArgs> {
    constructor(client: Client) {
        super("Deployments", client);
    }
}

export default DeploymentRepository;
